// global blueprint styles have to be imported before everything else
// (specifically, before we override them in page-specific styles)
import '@blueprintjs/core/lib/css/blueprint.css';
import '@blueprintjs/icons/lib/css/blueprint-icons.css';
import '@blueprintjs/popover2/lib/css/blueprint-popover2.css';
import '@blueprintjs/select/lib/css/blueprint-select.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConnectedRouter } from 'connected-react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import 'json-bigint-patch';

import App from './components/App';
import configureStore, { history } from './store';

import './index.css';

// import { generateElementWidths } from '@moleculeone/draw';
// const canvas = document.createElement('canvas');
// console.log(generateElementWidths(canvas));

const queryClient = new QueryClient();
const store = configureStore();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </QueryClientProvider>
    </Provider>
  </StrictMode>
);
